import UserAccess from "./UserAccess";

export default UserAccess;
